import React, { useState, useEffect, } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { uploadImage } from "../../utils/helpers/fileupload";
import { getSubjectTeacher } from "../../store/slices/subjectteacher";
import { getHomework, updateHomework } from "../../store/slices/homework";
import {
  FiHome,
  FiChevronRight,
} from "react-icons/fi";

const requiredMessages = {
  standardId: "Please select standard",
  sectionId: "Please select section",
  subjectId: "Please select subject",
  dueDate: "Please select due date",
  title: "Please enter title",
  description: "Please enter description",
};

//  extract filename from URL
const getFileName = (url) => {
  if (!url) return "";
  return url.split("/").pop();
};

export default function EditHomework() {
  const { id } = useParams();

  // token & teacher
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.data?.accessToken;
  const teacherId = user?.data?.teacherId;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [rawData, setRawData] = useState([]);
  const [standards, setStandards] = useState([]);
  const [sections, setSections] = useState([]);
  const [subjects, setSubjects] = useState([]);

  const [errors, setErrors] = useState({});
  const [file, setFile] = useState(null);
  const [existingFile, setExistingFile] = useState("");


  const [formData, setFormData] = useState({
    standardId: "",
    sectionId: "",
    subjectId: "",
    dueDate: "",
    title: "",
    description: "",
  });

  /* ---------- > Fetch teacher  */
  useEffect(() => {
    const fetchTeacherData = async () => {
      const res = await dispatch(getSubjectTeacher({ teacherId })).unwrap();
      const data = res?.data || [];

      setRawData(data);

      const uniqueStandards = [
        ...new Map(
          data.map((item) => [item.standardId._id, item.standardId]),
        ).values(),
      ];

      setStandards(uniqueStandards);
    };

    fetchTeacherData();
  }, [dispatch, teacherId]);

  /* Fetch homework by id <<<<---------- */

  useEffect(() => {
    const fetchHomeworkById = async () => {
      try {
        const res = await dispatch(getHomework({ id, teacherId })).unwrap();

        const homeworkdata = Array.isArray(res?.data) ? res.data[0] : res?.data;

        console.log("homeworkdata form edithomework page  : ", homeworkdata);

        if (!homeworkdata) {
          toast.error("Homework not found");
          return;
        }

        const standardId = homeworkdata.standardId?._id || homeworkdata.standardId || "";
        const sectionId = homeworkdata.sectionId?._id || homeworkdata.sectionId || "";
        const subjectId = homeworkdata.subjectId?._id || homeworkdata.subjectId || "";

        console.log("standardId", standardId);
        console.log("sectionId", sectionId);
        console.log("subjectId", subjectId)

        setFormData({
          standardId,
          sectionId,
          subjectId,
          dueDate: homeworkdata.dueDate
            ? homeworkdata.dueDate.split("T")[0]
            : "",
          title: homeworkdata.title || "",
          description: homeworkdata.description || "",
        });

        console.log(homeworkdata.dueDate, homeworkdata.title, homeworkdata.description)

        setExistingFile(homeworkdata.file || "");

        // ==== >sections
        const sec = rawData
          .filter((i) => i.standardId._id === standardId)
          .map((i) => i.sectionId);
        setSections([...new Map(sec.map((s) => [s._id, s])).values()]);

        // subjects <======
        const sub = rawData
          .filter(
            (i) =>
              i.standardId._id === standardId && i.sectionId._id === sectionId,
          )
          .map((i) => i.subjectId);
        setSubjects([...new Map(sub.map((s) => [s._id, s])).values()]);
      } catch {
        toast.error("Failed to load homework details");
      }
    };

    if (rawData.length && id) {
      fetchHomeworkById();
    }
  }, [dispatch, id, rawData]);

  /* ---------- > Handlers  */
  const handleStandardChange = (e) => {
    const standardId = e.target.value || "";

    setFormData((prev) => ({
      ...prev,
      standardId,
      sectionId: "",
      subjectId: "",
    }));

    const sec = rawData
      .filter((i) => i.standardId._id === standardId)
      .map((i) => i.sectionId);

    setSections([...new Map(sec.map((s) => [s._id, s])).values()]);
    setSubjects([]);
  };

  const handleSectionChange = (e) => {
    const sectionId = e.target.value || "";

    setFormData((prev) => ({
      ...prev,
      sectionId,
      subjectId: "",
    }));

    const sub = rawData
      .filter(
        (i) =>
          i.standardId._id === formData.standardId &&
          i.sectionId._id === sectionId,
      )
      .map((i) => i.subjectId);

    setSubjects([...new Map(sub.map((s) => [s._id, s])).values()]);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value || "" }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/png",
    ];

    if (!allowedTypes.includes(selectedFile.type)) {
      toast.error("Only PDF, JPG, PNG files allowed");
      e.target.value = "";
      return;
    }

    if (selectedFile.size > 10 * 1024 * 1024) {
      toast.error("File must be under 2MB");
      e.target.value = "";
      return;
    }

    setFile(selectedFile);
    setExistingFile("");
  };

  const validateForm = () => {
    let newErrors = {};
    Object.keys(requiredMessages).forEach((key) => {
      if (!formData[key]) newErrors[key] = requiredMessages[key];
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      let fileUrl = existingFile;

      // Upload only if a new file is selected
      if (file) {
        fileUrl = await uploadImage(file, token);
      }

      const payload = {
        id,
        teacherId,
        standardId: formData.standardId,
        sectionId: formData.sectionId,
        subjectId: formData.subjectId,
        dueDate: formData.dueDate,
        title: formData.title,
        description: formData.description,
        file: fileUrl, // String URL
      };

      await dispatch(updateHomework(payload)).unwrap();

      toast.success("Homework updated successfully");
      navigate("/teacher/homework");
    } catch (err) {
      console.error(err);

      toast.error(
        err?.response?.data?.message ||
        err?.message ||
        "Failed to update homework"
      );
    }
  };

  return (
    <>

      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/teacher/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>

            <FiChevronRight className="separator" />

            <Link to="/teacher/homework">Homework</Link>

            <FiChevronRight className="separator" />

            <span className="active">Edit Homework</span>
          </div>

        </div>
      </div>
      <div className="acs-card">
        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            <Col md={3}>
              <Form.Label>Standard</Form.Label>
              <Form.Select
                value={formData.standardId}
                onChange={handleStandardChange}
              >
                <option value="">Select Standard</option>
                {standards.map((s) => (
                  <option key={s._id} value={s._id}>
                    {s.name}
                  </option>
                ))}
              </Form.Select>
              {errors.standardId && (
                <small className="text-danger">{errors.standardId}</small>
              )}
            </Col>

            <Col md={3}>
              <Form.Label>Section</Form.Label>
              <Form.Select
                value={formData.sectionId}
                onChange={handleSectionChange}
              >
                <option value="">Select Section</option>
                {sections.map((s) => (
                  <option key={s._id} value={s._id}>
                    {s.name}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col md={3}>
              <Form.Label>Subject</Form.Label>
              <Form.Select
                name="subjectId"
                value={formData.subjectId}
                onChange={handleChange}
              >
                <option value="">Select Subject</option>
                {subjects.map((s) => (
                  <option key={s._id} value={s._id}>
                    {s.name}
                  </option>
                ))}
              </Form.Select>
            </Col>

            <Col md={3}>
              <Form.Label>Due Date</Form.Label>
              <Form.Control
                type="date"
                name="dueDate"
                value={formData.dueDate}
                onChange={handleChange}
              />
            </Col>

            <Col md={4}>
              <Form.Label>Title</Form.Label>
              <Form.Control
                name="title"
                value={formData.title}
                onChange={handleChange}
              />
            </Col>


            <Col md={4}>
              <Form.Label>File</Form.Label>



              <Form.Control
                type="file"
                accept=".pdf,.jpg,.png"
                onChange={handleFileChange}
              />
              {existingFile && !file && (

                <div className="mb-1">
                  <small>Existing file:</small>{" "}
                  <a href={existingFile} target="_blank" rel="noreferrer" style={{ color: "#2563eb", fontWeight: 500, textDecoration: "none", fontSize: "10px" }}>
                    📄 {getFileName(existingFile)}
                  </a>
                </div>

              )}
            </Col>
            <Col md={4}>
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                name="description"
                value={formData.description}
                onChange={handleChange}
                style={{ height: "6rem", resize: "none" }}
              />
            </Col>

          </Row>

          <div className="an-actions mt-5">
            <button
              type="button"
              className="btn-cancel"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            <button type="submit" className="btn-submit">
              Update
            </button>
          </div>
        </Form>

      </div>
    </>
  );
}
